module.exports = __webpack_public_path__ + "img/hiw.ec16f904.png";